const wrapper = "_275wq7xovd";
const message = "_275m1de4y92";
const svg = "_275snvetu9";

export { message, svg, wrapper };
import "./loader.styles.linaria.module.css";
//# sourceMappingURL=loader.styles.js.map
